import api from '@/api';

const tabName = localStorage.getItem('activeTabOwnerPanelName') || 'analytics';
const showReportByChosen = {
    tag: localStorage.getItem('showReportByChosen') || 'by_questions'
};

export default {
    namespaced: true,

    state: {
        makeOwnerBool: JSON.parse(localStorage.getItem('makeOwnerBool')) || false,
        analyticTimeFilter: {
            name: 'own_last7days',
            attr: 'week'
        },
        analyticSiteFilter: {
            tag: 'all',
            uid: null
        },
        analyticSiteFilterDefault: {
            tag: 'all',
            uid: null
        },
        customDate: {
            date_from: undefined,
            date_to: undefined,
        },
        siteListDropdown: [],
        showReportByChosen: showReportByChosen,
        activeTabName: tabName,
        analyticTabIndex: 2, // analytic tab index
        sideBarToggle: false
    },
    getters: {
        getActiveTab(state) {
            let index = 2
            switch (state.activeTabName) {
                case 'company': {
                    index = 0
                    break;
                }
                case 'sites': {
                    index = 1
                    break;
                }
                case 'analytics': {
                    index = 2
                    break;
                }
                case 'map': {
                    index = 3
                    break;
                }
                default: {
                    index = 2
                }
            }
            return index
        },
        analyticTabIndex(state) {
            return state.analyticTabIndex;
        },
        getSideBarToggle(state) {
            return state.sideBarToggle
        }
    },
    mutations: {

        setCustomDate(state, {date_from, date_to}){
            if (date_from) {
               state.customDate.date_from = date_from
            }
            if (date_to) {
                state.customDate.date_to = date_to
            }
        },

        setSiteListDropdown(state, value) {
            state.siteListDropdown = value
        },
        setSideBarToggle(state, value) {
            state.sideBarToggle = value
        },

        showReportByFilter(state, value) {
            state.showReportByChosen = {
                tag: value
            };
            localStorage.setItem('showReportByChosen', value)
        },

        setOwner(state, bool) {
            state.makeOwnerBool = bool;
            if (bool) {
                localStorage.setItem('makeOwnerBool', bool);
            } else {
                localStorage.removeItem('makeOwnerBool');
            }
        },
        setAnalyticFilter(state, {analyticTimeFilter, analyticSiteFilter}) {
            if (analyticTimeFilter) {
                state.analyticTimeFilter = analyticTimeFilter
            }
            if (analyticSiteFilter) {
                state.analyticSiteFilter = analyticSiteFilter
            }
        },
        setActiveTab(state, index) {
            let name = ''
            switch (index) {
                case 0: {
                    name = 'company'
                    break;
                }
                case 1: {
                    name = 'sites'
                    break;
                }
                case 2: {
                    name = 'analytics'
                    break;
                }
                case 3: {
                    name = 'map'
                    break;
                }
                default: {
                    name = 'analytics'
                }
            }
            state.activeTabName = name
            localStorage.setItem('activeTabOwnerPanelName', name)
        },
    },
    actions: {

        async fetchComments(context, {body}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/comments`;
            try {
                const responce = await api.request('post', url, body);
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async fetchLastVotes(context, {body}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/lastVotes`;
            try {
                const responce = await api.request('post', url, body);
                return responce.data
            } catch (error) {
                throw error;
            }
        },


        async deleteAccount(context, { requested = false }) {
            const guid = context.rootState.auth.userInfo.guid
            const url = `/users/${guid}/delete`;
            const type = requested ? 'delete' : 'post'
            try {
                const responce = await api.request(type, url);
                console.log(responce)
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async downgradeToClient(context) {
            const guid = context.rootState.auth.userInfo.guid
            const url = `/users/${guid}/managerRole`;
            try {
                const responce = await api.request('delete', url);
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async getSiteslist(context) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/sites`;
            try {
                const responce = await api.request('get', url);
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async deleteSite(context, uid_site) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/sites/${uid_site}`;
            try {
                const responce = await api.request('delete', url);
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async editSite(context, {body, uid_site}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/sites/${uid_site}`;
            try {
                const responce = await api.request('put', url, body);
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async addSite(context, body) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/sites`;
            try {
                const responce = await api.request('post', url, body);
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async makeOwner() {
            const url = `/api/v1/registerAsBusinessOwner`;
            try {
                return await api.request('post', url);
            } catch (error) {
                throw error;
            }
        },

        async changeOwnerRoleToClient() {
            const url = `/users/makeClient`;
            return await api.request('put', url);
        },

        async saveBusinessInfo(context, organization) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}`;
            try {
                return await api.request('put', url, organization);
            } catch (error) {
                throw error;
            }
        },

        async getManagerReport(context, obj) {
            const data = obj
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/managerReport`;
            return (await api.request("post", url, data)).data
        },

        async getMapReport(context, obj) {
            const data = obj
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/mapReport`;
            return (await api.request("post", url, data)).data
        },

        async getAvailableSites(context) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/sites/available`;
            return (await api.request('get', url)).data
        },

        async getMapReportGeoJson(context, obj) {
            const data = obj
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/map/votes/geo-json`;
            return (await api.request("post", url, data)).data
        },

        async getMapQuestionsGeoJson(context, obj) {
            const data = obj
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/map/questions/geo-json`;
            return (await api.request("post", url, data)).data
        },

        async getMapRatesReport(context, obj) {
            const data = obj
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/mapReport/rates`;
            return (await api.request("post", url, data)).data
        },

        async getOwnerReport(context, obj) {
            const data = obj
            const url = `/api/v1/ownerReport`;
            try {
                const responce = await api.request("post", url, data);
                return responce.data
            } catch (error) {
                throw error;
            }
        },
        async requestStickers(context, obj) {
            const data = obj
            const url = `/admin/request_stickers`;
            try {
                const responce = await api.request("post", url, data);
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async logUserAction(context, obj) {
            const data = obj
            const url = `/user-action`;
            return (await api.request("post", url, data)).data
        },


    },
};
